import {
  compose,
  lifecycle,
  withProps,
  withPropsOnChange,
  withState,
  withHandlers,
  branch,
  renderNothing,
} from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import DeepLinkRedirect from '../components/DeepLinkRedirect';
import withExtensions from '../../extensions/withExtensions';
import { getExtension } from '../../extensions';
import { getBrandReservation, getReservation } from '../../reservation/actions';
import sendAppLinkSms from '../actions';

const DeepLinkRedirectContainer = compose(
  withExtensions,
  withRouter,
  connect(
    (state, ownProps) => ({
      brandRoute: ownProps.params.brandRoute,
      confirmationCode: ownProps.params.confirmationCode,
      extension: getExtension(state, ownProps.params.brandRoute),
      sendAppLinkSms,
    }),
  ),
  withState('reservation', 'setReservation', null),
  withState('fetchReservationError', 'setFetchReservationError', false),
  withState('smsSent', 'setSmsSent', false),
  withState('brandId', 'setBrandId', null),
  withHandlers({
    send: props => () => props.sendAppLinkSms(props.brandId, props.reservation.appointment.customer.phone).then(() =>
      props.setSmsSent(true)
    ),
    fetchReservation: props => () => {
      try {
        let reservationCall;
        if (props.brandRoute) {
          props.setBrandId(props.extension.brandId);
          reservationCall = getBrandReservation(props.extension.brandId, props.params.confirmationCode);
        } else {
          reservationCall = getReservation(props.params.confirmationCode);
        }
        reservationCall.then(reservation => props.setReservation(reservation));
      } catch (err) {
        props.setFetchReservationError(err);
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.brandRoute) {
        this.props.fetchExtension(this.props.brandRoute, true);
      }
    },
  }),
  withPropsOnChange(
    ['extension'],
    async (props) => {
      await props.fetchReservation();
    }
  ),
  branch(
    props => !props.confirmationCode || !props.reservation,
    renderNothing,
  ),
  withProps(({ reservation }) => (
    {
      customer: reservation.appointment && reservation.appointment.customer,
    }
  )),
);

export default DeepLinkRedirectContainer(DeepLinkRedirect);



// WEBPACK FOOTER //
// ./src/app/mobileApp/containers/DeepLinkRedirect.js